import { render, staticRenderFns } from "./LinkText.vue?vue&type=template&id=28060d28&scoped=true"
import script from "./LinkText.vue?vue&type=script&lang=js"
export * from "./LinkText.vue?vue&type=script&lang=js"
import style0 from "./LinkText.vue?vue&type=style&index=0&id=28060d28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28060d28",
  null
  
)

export default component.exports